interface EmailVerificationGuideProps {
  className?: string;
}

export function EmailVerificationGuide({ className = '' }: EmailVerificationGuideProps) {
  return (
    <div className={`bg-[#F5F5F5] rounded-xl p-8 max-w-lg mx-auto ${className}`}>
      <h2 className="text-[20px] font-semibold text-[#222222] mb-4">다음 단계로 이렇게 시작해 보세요</h2>
      <ul className="space-y-3 text-[18px] text-[#606060]">
        <li className="flex items-start gap-3">
          <span className="text-[#51C854] font-bold">•</span>
          <span>홈에서 오늘의 마감 할인 상품을 확인해 보세요</span>
        </li>
        <li className="flex items-start gap-3">
          <span className="text-[#51C854] font-bold">•</span>
          <span>마이페이지에서 추천 코드를 확인하고 친구와 혜택을 나눠보세요</span>
        </li>
        <li className="flex items-start gap-3">
          <span className="text-[#51C854] font-bold">•</span>
          <span>단골 가게를 등록하면 빠르게 재주문할 수 있어요</span>
        </li>
      </ul>
    </div>
  );
}
